import React from "react";
import { Container } from "@telia/teddy";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import "./RetailerDashboard.less";
import ContinueSection from "../../components/molecules/ContinueSection/ContinueSection";
import { Sidebar } from "../../components/molecules/Sidebar";
import ShoppingCart from "../../components/organisms/ShoppingCart/ShoppingCart";
import { RootState } from "../../../../../models";
import { isAddingSubscription as isAddingSubscriptionSelector } from "../../state/selectors/subscriptionStepsSelectors";
import { getActiveSubscription } from "../../../checkout/state/selectors/cartSelectors";
import PAGES from "../../../../../constants/pages";

const RetailerDashboard = () => {
    const location = useLocation();
    const isAddingSubscription = useSelector((state: RootState) => isAddingSubscriptionSelector(state));
    const activeSubscription = useSelector((state: RootState) => getActiveSubscription(state));
    return (
        <div className="retailer-dashboard">
            <Sidebar />
            <main className="retailer-dashboard__main-content">
                <Container mr="200" ml="200">
                    <Outlet />
                    {(!location.pathname.includes(PAGES.RETAILER.ORDER.SUBSCRIPTION.SUFFIX) ||
                        (!isAddingSubscription && !activeSubscription)) && <ContinueSection path={location.pathname} />}
                </Container>
            </main>
            {!location.pathname.includes("/nexus/bestilling/kvittering/") && <ShoppingCart />}
        </div>
    );
};

export default RetailerDashboard;
